import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOPatientFarmacologicRecord } from "../models/BOPatientFarmacologicRecord.model";
import { BOTranspPatientAllergies } from "../models/auxiliars/BOTranspPatientAllergies.model";
import { BOTranspFarmacologicRecords } from "../models/auxiliars/BOTransPatientFarmacologicRecord.model";

@Injectable({
  providedIn: 'root'
}

)
export class PatientFarmacologicRecordService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/PatientFarmacologicRecord/';

    constructor(private http:HttpClient){}
//#region First

    getAllByPatientId(patientId:number):Observable<BOPatientFarmacologicRecord[]>{
        return this.http.get<BOPatientFarmacologicRecord[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    }

    createOrUpdatePatientFarmacologicRecords(transp:BOTranspFarmacologicRecords):Observable<BOPatientFarmacologicRecord[]>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(transp);
          return this.http.post<BOPatientFarmacologicRecord[]>(this.myAppUrl + this.myApiUrl + 'createOrUpdatePatientFarmacologicRecords',body,httpOptions);
    }
//#endregion First

//#region Single
  createOrUpdatePatientFarmacologicRecordSingle(patientId:number, disease:BOPatientFarmacologicRecord):Observable<BOPatientFarmacologicRecord>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOPatientFarmacologicRecord>(this.myAppUrl + this.myApiUrl + 'createOrUpdatePatientFarmacologicRecordSingle/' + patientId,body,httpOptions);
  }

deletePatientFarmacologicRecordSingle(id:number):Observable<BOPatientFarmacologicRecord>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOPatientFarmacologicRecord>(this.myAppUrl + this.myApiUrl + 'deletePatientFarmacologicRecordSingle/' + id,null,httpOptions);
    }


//#endregion Single

}
